import React, {FC, PropsWithChildren} from 'react';

export const CellsConversationsDragType = 'CELLS_CONVERSATIONS';

// Because the preview images break in Jest.
export const ConversationCellDragSource: FC<PropsWithChildren<unknown>> = (props) => <>{props.children}</>;
